import { Box, Typography, IconButton, Link, Grid, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/img/new_logo.svg'
import linkedin_icon from '../../assets/img/linkedin_icon.svg';
import facebook_icon from '../../assets/img/facebook_icon.svg';
import instagram_icon from '../../assets/img/instagram_icon.svg';
import x_icon from '../../assets/img/x_icon.svg';
import colors from 'colors/color';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={{ px: 3, py: 8 }}>
      <Container sx={{ py: 4 }}>
        <Grid container spacing={4}>
          {/* Logo and description section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Link href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={logo} alt="TALNETHYIRE Logo" />
              </Link>
            </Box>

            <Typography
              color={colors.secondary}
              sx={{
                mt: 3,
                mb: 2,
                lineHeight: '18px',
                fontWeight: 400,
                fontSize: 12,
                fontFamily: 'Poppins'
              }}>
              {t('footer.description')}
            </Typography>

            <Box sx={{ display: 'flex', gap: 0 }}>
              <IconButton
              onClick={() => window.open('https://www.linkedin.com/company/talenty-hire/', '_blank')}
                size="small"
                sx={{
                  borderRadius: '8px',
                  color: colors.primary,
                }}
              >
                <img src={linkedin_icon} alt={t('footer.socialMedia.linkedin')} />
              </IconButton>
              <IconButton
              onClick={() => window.open('https://www.facebook.com/share/1aefJ9qw4T/', '_blank')}
                size="small"
                sx={{
                  borderRadius: '8px',
                  color: colors.primary,
                }}
              >
                <img src={facebook_icon} alt={t('footer.socialMedia.facebook')} />
              </IconButton>
              <IconButton
                size="small"

                onClick={() => window.open('https://www.instagram.com/talentyhire?igsh=MWxiYjZia202bXF1cA==', '_blank')}
                sx={{
                  borderRadius: '8px',
                  color: colors.primary,
                }}
              >
                <img src={instagram_icon} alt={t('footer.socialMedia.instagram')} />
              </IconButton>
              <IconButton
              onClick={() => window.open('https://x.com/TalentyHire', '_blank')}
                size="small"
                sx={{
                  borderRadius: '8px',
                  color: colors.primary,
                }}
              >
                <img src={x_icon} alt="X (Twitter)" />
              </IconButton>
            </Box>
          </Grid>

          {/* Empty space column */}
          <Grid item xs={12} md={2}>
            {/* This creates the space between sections */}
          </Grid>

          {/* Job offers section */}
          <Grid item xs={12} md={2}>
            <Typography
              sx={{
                fontFamily: 'Kontora',
                fontWeight: 700,
                fontSize: '28px',
                lineHeight: '28.11px',
                letterSpacing: '0%',
              }}
            >
              {t('footer.links.offers')}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, pt: 2 }}>
              {['IT Career', 'Design Career', 'Finance Career', 'More Careers'].map((item) => (
                <Box component="li" key={item} sx={{ mb: 1 }}>
                  <Link href="#"
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '21px',
                      letterSpacing: '0%',
                      color: '#00000080',
                      textDecoration: 'none',
                    }}
                  >
                    {item}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Spontaneous offers section */}
          <Grid item xs={12} md={2}>
            <Typography sx={{
              fontFamily: 'Kontora',
              fontWeight: 700,
              fontSize: '28px',
              lineHeight: '28.11px',
              letterSpacing: '0%',
            }}>
              {t('navBar.spontaneous')}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, pt: 2 }}>
              {['IT Career', 'Design Career', 'Finance Career', 'More Careers'].map((item) => (
                <Box component="li" key={item} sx={{ mb: 1 }}>
                  <Link href="#" sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '21px',
                    letterSpacing: '0%',
                    color: '#00000080',
                    textDecoration: 'none',
                  }}>
                    {item}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography sx={{
              fontFamily: 'Kontora',
              fontWeight: 700,
              fontSize: '28px',
              lineHeight: '28.11px',
              letterSpacing: '0%',
            }}>
              {t('navBar.policies')}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, pt: 2 }}>
              {['Talenty Hire Politiques'].map((item) => (
                <Box component="li" key={item} sx={{ mb: 1 }}>
                  <Link href="/policies" sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '21px',
                    letterSpacing: '0%',
                    color: '#00000080',
                    textDecoration: 'none',
                  }}>
                    {item}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}